import * as React from "react";
import styled from "styled-components";

import {
  Grid,
  List,
  ListItemButton as MuiListItemButton,
  ListItemText as MuiListItemText,
} from "@mui/material";

const Wrapper = styled.div`
  padding: ${(props) => 0} ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItemButton = styled(MuiListItemButton)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          sx={{ display: { xs: "none", md: "block" } }}
          container
          item
          xs={12}
          md={6}
        >
          <List style={{ padding: 0 }}>
            <ListItemButton style={{ padding: 7 }} component="a" href="#">
              <ListItemText primary="Support" />
            </ListItemButton>
            <ListItemButton style={{ padding: 7 }} component="a" href="#">
              <ListItemText primary="Help Center" />
            </ListItemButton>
            <ListItemButton style={{ padding: 7 }} component="a" href="#">
              <ListItemText primary="Privacy" />
            </ListItemButton>
            <ListItemButton style={{ padding: 7 }} component="a" href="#">
              <ListItemText primary="Terms of Service" />
            </ListItemButton>
          </List>
        </Grid>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List style={{ padding: 0 }}>
            <ListItemButton style={{ padding: 7 }}>
              <ListItemText
                primary={`© ${new Date().getFullYear()} - Discovery Management Group LLC`}
              />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
